import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query"
import axios from "axios";
import { apiRoot, SetUserContext, getUserFromDbUser } from "..";

const UserRegistration = () => {
  const setUser = useContext(SetUserContext);
  const navigate = useNavigate();

  const [inputs, setInputs] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const loginMutation = useMutation((loginData) => {
    return axios.post(apiRoot + '/login', loginData);
  },
  {
    onSuccess: (response) => {
      const jwtToken = response.data.token;
      window.sessionStorage.setItem('jwtToken', jwtToken);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken; // TODO
      setUser(getUserFromDbUser(response.data.user));
      navigate("/aktuality");
    },
    onError: (error) => {
      setErrorMessage(error.message); // TODO json -> errorCode -> hlaska
      window.scrollTo(0, 0);
    }
  });

  const handleChange = (event) => {
    if (!loginMutation.isLoading) {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage(null);

    if (!inputs.mail || !inputs.passwd) { // TODO trim
      setErrorMessage('Některé povinné položky nejsou vyplněné.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    loginMutation.mutate(inputs);
  }

  return (
    <>
<div>
<span className="align-middle">
<i className="fa fa-handshake-o fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Žádost o registraci nového uživatele</h2>
</span>
</div>

<form>

<table>
<tbody>
<tr>
<td><div className="alert alert-danger" role="alert">{"err_txt"}</div></td>
</tr><tr>
<td><strong>Jméno a příjmení:</strong></td>
</tr><tr>
<td><input type="text" className="form-control" name="name" size="50" /></td>
</tr><tr>
<td><strong>Číslo bytu:</strong></td>
</tr><tr>
<td><input type="text" className="form-control" name="appartmentNo" size="30" /></td>
</tr><tr>
<td><strong>E-mail:</strong> <em>(Váš e-mail nebude na portálu zveřejněn. Bude sloužit jako Vaše přihlašovací jméno a bude k dispozici výboru SVJ pro komunikaci související se správou domu - pozvánky na shromáždění vlastníků, apod.)</em></td>
</tr><tr>
<td><input type="text" className="form-control" name="mail" size="30" /></td>
</tr><tr>
<td><strong>Telefon:</strong> <em>(Vaše telefonní číslo nebude na portálu zveřejněno. Bude k dispozici výboru SVJ pro případ nouze - havárie vody, apod.)</em></td>
</tr><tr>
<td><input type="text" className="form-control" name="phone" size="30" /></td>
<td>&nbsp;</td>
<td></td>
</tr><tr>
<td>&nbsp;</td>
</tr><tr>
<td><button type="submit" className="btn btn-primary">Zaregistrovat</button></td>
</tr>
<tr>
<td>&nbsp;</td>
</tr>
<tr>
<td>
Vaše žádost o registraci bude po odeslání zkontrolována a schválena některým z členů výboru SVJ.<br />
Po schválení žádosti obdržíte na zadaný e-mail úvodní heslo, které si po přihlášení do portálu budete moci změnit.
</td>
</tr>
</tbody>
</table>

</form>
    </>
  );
};

export default UserRegistration;